/* eslint-disable */
import React from 'react';
import {
    ShowView,
    TabbedShowLayout,
    ShowContextProvider,
    useShowController,
    useRecordContext,
    useResourceContext,
} from 'react-admin';
import { ShowTitleByLowerName } from '../Scaffolding';

import { ModuleAdditionalInfoShowTab } from './Tabs/ModuleAdditionalInfoTabs';
import { ModuleInformationShowTab } from './Tabs/ModuleInformationTabs';
import { useClosedStatusId } from '../../lib/useClosedStatusId';

const ModuleShowView = (props) => {
    const record = useRecordContext();
    const resource = useResourceContext();
    const closedStatusId = useClosedStatusId();

    const hideEditAction =
        resource === 'ThisSpecificModuleVersion' &&
        record?.statusId === closedStatusId;

    if (hideEditAction) {
        return (
            <ShowView title={<ShowTitleByLowerName />} actions={false}>
                {props.children}
            </ShowView>
        );
    }
    return <ShowView title={<ShowTitleByLowerName />}>{props.children}</ShowView>;
};

const ModuleShow = (props) => {
    const controllerProps = useShowController();

    return (
        <ShowContextProvider value={controllerProps}>
            <ModuleShowView>
                <TabbedShowLayout>
                    <ModuleInformationShowTab {...props} />
                    <ModuleAdditionalInfoShowTab {...props} />
                </TabbedShowLayout>
            </ModuleShowView>
        </ShowContextProvider>
    );
};

export default ModuleShow;
